import { useEffect, useMemo } from 'react'
import { useSetAtom } from 'jotai'
import { customerModelAtom } from 'pages/Customers/atoms/customersAtoms'
import { CustomerModels } from 'pages/Customers/helpers/types'
import { AccountCapabilities } from 'types/capabilities/capabilities'

export const useCustomerModel = (accountCapabilities: AccountCapabilities) => {
  const setCustomerModelAtom = useSetAtom(customerModelAtom)

  const {
    isPrincipleCustomerCompanyCapabilityEnabled,
    isPrincipleCustomerIndividualCapabilityEnabled,
    isEmbeddedCustomerCompanyCapabilityEnabled,
    isEmbeddedCustomerIndividualCapabilityEnabled,
    isPartnerManagedCustomerCompanyCapabilityEnabled,
    isPartnerManagedCustomerIndividualCapabilityEnabled,
  } = accountCapabilities || {}

  const isPrincipleCustomerEnabled = useMemo(
    () =>
      isPrincipleCustomerCompanyCapabilityEnabled || isPrincipleCustomerIndividualCapabilityEnabled,
    [isPrincipleCustomerCompanyCapabilityEnabled, isPrincipleCustomerIndividualCapabilityEnabled]
  )

  const isEmbeddedCustomerEnabled = useMemo(
    () =>
      isEmbeddedCustomerCompanyCapabilityEnabled || isEmbeddedCustomerIndividualCapabilityEnabled,
    [isEmbeddedCustomerCompanyCapabilityEnabled, isEmbeddedCustomerIndividualCapabilityEnabled]
  )

  const isPartnerManagedCustomerEnabled = useMemo(
    () =>
      isPartnerManagedCustomerCompanyCapabilityEnabled ||
      isPartnerManagedCustomerIndividualCapabilityEnabled,
    [
      isPartnerManagedCustomerCompanyCapabilityEnabled,
      isPartnerManagedCustomerIndividualCapabilityEnabled,
    ]
  )
  const customerModel = useMemo(() => {
    if (isEmbeddedCustomerEnabled) return CustomerModels.EMBEDDED
    if (isPartnerManagedCustomerEnabled) return CustomerModels.RELIANCE
    if (isPrincipleCustomerEnabled) return CustomerModels.NESTED
  }, [isEmbeddedCustomerEnabled, isPrincipleCustomerEnabled, isPartnerManagedCustomerEnabled])

  const isCustomersEnabled = useMemo(() => !!customerModel, [customerModel])

  useEffect(() => {
    setCustomerModelAtom(customerModel)
  }, [customerModel])

  return { isCustomersEnabled, customerModel }
}
